import { Component, OnInit } from '@angular/core';
import { Company } from 'identity-webapi-client';
import { SituRenderServiceWebApiClient, ListEnvironmentsByBuilderRequest, EnvironmentSettings } from 'siturenderservice-webapi-client';
import { AuthService, BreadcrumbService, IProductNameConfiguration, ProductNameService, StateService } from '../../../services';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';

@Component({
  selector: 'app-warp-product-environments',
  templateUrl: './warp-product-environments.component.html',
  styleUrls: ['./warp-product-environments.component.less']
})
export class WarpProductEnvironmentsComponent extends SituBaseComponent implements OnInit {
  selectedProduct: IProductNameConfiguration | undefined;
  products: IProductNameConfiguration[] | undefined;

  environments: EnvironmentSettings[] = [];
  companies: Company[] = [];

  private _loading = false;
  public get loading(): boolean {
    return this._loading;
  }

  public set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  constructor(
    private situRenderServiceClient: SituRenderServiceWebApiClient,
    authService: AuthService,
    stateService: StateService,
    private breadcrumbService: BreadcrumbService,
    private productNameService: ProductNameService) {
    super(authService, stateService);
  }  ngOnInit(): void {
    super.ngOnInit();
    
    this.products = [
      ...this.productNameService.productNameConfigurations,
      this.productNameService.getVanityConfiguration(),
      this.productNameService.getInsightsConfiguration(),
      this.productNameService.getUnrealConfiguration(),
      this.productNameService.getConnectConfiguration()
    ];

    this.selectedProduct = this.productNameService.productNameConfiguration || this.products[0];
    this.breadcrumbService.setParam('productName', `> ${this.selectedProduct?.product ?? ""}`);
    
    // Now that product is set up, load environments if we have a company
    if (this.selectedCompany && this.selectedProduct) {
      this.loadEnvironments();
    }
  }  protected onSelectedCompanyChange(): void {
    // Only load environments if we have both company and product set up
    if (this.selectedProduct) {
      this.loadEnvironments();
    }
  }
    loadEnvironments() {
    if (!this.selectedCompany) {
      return;
    }

    this.loading = true;

    const request = new ListEnvironmentsByBuilderRequest();
    request.builder = this.selectedCompany.code;
    request.product = this.selectedProduct?.productName;

    this.situRenderServiceClient.listEnvironmentsByBuilder(request).then((response: any) => {
      if (response.success) {
        this.environments = response.environments ?? [];
        this.environments.forEach(x => x.referenceKeyCuttoffs ?? []);
      } else {
        this.environments = [];
      }
      this.loading = false;
    }, (error: any) => {
      this.environments = [];
      console.error('Failed to load environments:', error);
      this.loading = false;
    });
  }
  productChange(product: any) {
    if (product === undefined) return;

    this.breadcrumbService.setParam('productName', `> ${product.value?.product ?? ""}`);

    this.selectedProduct = product.value;
    this.productNameService.productNameConfiguration = product.value;
    this.loadEnvironments();
  }
}
